import RoutesMap from "./RouteControl"

// Static menu — same modules, order and grouping as the live customer portal
// (the portal has no permission API, so the menu is not fetched).
const SidebarMenu = [
    { label: 'Dashboard', icon: 'Gauge', route: RoutesMap.DASHBOARD.path },
    {
        label: 'Plans', icon: 'Layers', children: [
            RoutesMap.ACTIVE_PLAN,
            RoutesMap.FUTURE_PLAN,
            RoutesMap.PLAN_HISTORY,
        ]
    },
    {
        label: 'Payments', icon: 'CreditCard', children: [
            RoutesMap.PAYMENT_LIST,
            RoutesMap.CHARGES_LIST,
        ]
    },
    { label: 'Purchase', icon: 'ShoppingCart', route: RoutesMap.PURCHASE_LIST.path },
    { label: 'Sessions', icon: 'CalendarClock', route: RoutesMap.SESSION_LIST.path },
    { label: 'Ticket', icon: 'Ticket', route: RoutesMap.TICKET_LIST.path },
    {
        label: 'Recharge', icon: 'ShoppingBag', children: [
            RoutesMap.RECHARGE,
            RoutesMap.PURCHASE_HISTORY,
        ]
    },
    { label: 'Modem Password', icon: 'KeyRound', route: RoutesMap.MODEM_PASSWORD.path },
    { label: 'Self Care Password', icon: 'ShieldCheck', route: RoutesMap.SELFCARE_PASSWORD.path },
]

export default SidebarMenu;
